import React, { useState } from 'react';
import TrustBadges from './TrustBadges';

const cfg = (typeof window !== 'undefined' && window.CHECKOUT_NEXT) || {};

// Read-only order synopsis. Items are NOT editable here. Rendered twice by the
// layout: as a desktop sticky sidebar, and as a mobile bottom sheet whose header
// (total) stays visible and expands the item list on tap.
export default function OrderSummary({ variant = 'sidebar', cart: cartProp, onQty, busy, docType }) {
  const cart = cartProp || cfg.cart || null;
  const [open, setOpen] = useState(false);

  if (!cart) return null;

  const isInvoice = docType === 'invoice';
  // Receipt: no VAT breakdown — just a note that the prices include ΦΠΑ.
  const vatPercents = (cart.taxLines || []).map((t) => (t.percent === Math.round(t.percent) ? String(Math.round(t.percent)) : String(t.percent).replace('.', ',')));
  const vatNote = !isInvoice && vatPercents.length ? `Συμπεριλαμβάνεται ΦΠΑ ${vatPercents.join('%, ')}%` : '';

  const rows = (
    <>
      <ul className={`cn-sum__items ${busy ? 'is-busy' : ''}`}>
        {(cart.items || []).map((it, i) => (
          <li className="cn-sum__item" key={it.key || i}>
            <span className="cn-sum__thumb">
              {it.image ? <img src={it.image} alt="" loading="lazy" /> : null}
            </span>
            <span className="cn-sum__name">
              {it.name}
              {/* Quantity is read-only at checkout — edit it back in the cart. */}
              <span className="cn-sum__qtytxt">×{it.qty}</span>
            </span>
            <span className="cn-sum__price">{it.total}</span>
          </li>
        ))}
      </ul>
      <dl className="cn-sum__totals">
        <div><dt>Υποσύνολο</dt><dd>{cart.subtotal}</dd></div>
        {cart.discount && <div className="cn-sum__discount"><dt>Έκπτωση</dt><dd>−{cart.discount}</dd></div>}
        <div><dt>Μεταφορικά</dt><dd>{cart.shipping || 'Δωρεάν'}</dd></div>
        {(cart.fees || []).map((f, i) => (
          <div key={i}><dt>{f.name}</dt><dd>{f.amount}</dd></div>
        ))}
        {isInvoice && (cart.taxLines || []).length > 0 && (
          <div className="cn-sum__vatrow cn-sum__vatrow--first"><dt>Καθαρή αξία</dt><dd>{cart.netTotal}</dd></div>
        )}
        {isInvoice && (cart.taxLines || []).map((t, i) => (
          <div className="cn-sum__vatrow" key={`vat${i}`}><dt>{t.label}</dt><dd>{t.amount}</dd></div>
        ))}
        {cart.walletPayment && (
          <div className="cn-sum__wallet"><dt>{cart.walletPayment.label}</dt><dd>{cart.walletPayment.amount}</dd></div>
        )}
      </dl>
      {vatNote && <p className="cn-sum__vatnote">{vatNote}</p>}
    </>
  );

  if (variant === 'mobile') {
    return (
      <div className={`cn-sum cn-sum--mobile ${open ? 'is-open' : ''}`}>
        <button type="button" className="cn-sum__bar" onClick={() => setOpen((o) => !o)} aria-expanded={open}>
          <span className="cn-sum__bar-label">
            {open ? 'Απόκρυψη σύνοψης' : 'Σύνοψη παραγγελίας'}
            <span className={`cn-sum__chevron ${open ? 'up' : ''}`} aria-hidden="true">⌃</span>
          </span>
          <span className="cn-sum__bar-total">{cart.walletPayment ? cart.walletPayment.payable : cart.total}</span>
        </button>
        {open && <div className="cn-sum__body">{rows}</div>}
      </div>
    );
  }

  return (
    <aside className="cn-sum cn-sum--sidebar">
      <h2 className="cn-sum__title">Σύνοψη παραγγελίας</h2>
      {rows}
      <div className="cn-sum__grand">
        <span>Σύνολο</span>
        <span>{cart.walletPayment ? cart.walletPayment.payable : cart.total}</span>
      </div>
      {/* Right under the amount — where the "is this safe?" question actually
          gets asked. Sidebar only: the mobile variant is a fixed bar and every
          pixel there pushes the form up. */}
      <TrustBadges />
    </aside>
  );
}
